GP.vent.on('init_js:user:register_success_help', function(self) {

    self.send_validation = function() {
        var email_addy = $('#email_text').val();

        if(!email_addy) {
            display_msg('email address is invalid');
            return false;
        } else {
            $.ajax({
                url: '/members/user/validate_email/?ajax=1&mod_email=1&email='+ email_addy,
                dataType: 'html',
                success: function(data) {
                    $('#update-email').hide();
                    $('#message_text').html(data);
                    $('#message').show();
                    $('#user_email').text(email_addy);
                }
            });
        }
    };

    self.resend_validation = function() {
        $.ajax({
            url: '/members/user/validate_email/?ajax=1&send_conf=1',
            dataType: 'html',
            success: function(data) {
                $('#resend_email_txt').html(data);
            }
        });
    };

    $('#register-success-help-wrap').on("click", "#resend_email", self.resend_validation);
	$('#register-success-help-wrap').on("click", "#update_email_btn", self.send_validation);
	$('#register-success-help-wrap').on("click", "#clear_msg", function() {
        $('#message_text').html(null);
        $('#message').hide();
        $('#update-email').show();
    });

});

GP.vent.on('init_js:user:register_success', function(self) {
    var $modal_content = $("#gmail-modal");
    var $flash_content = $("#flashcontent");

    // we have the gmail modal to show
    if ($modal_content.length > 0) {
        var url_params = window.location.search;

        // open modal after post reg modal if we have this param
        if (url_params.indexOf('just_registered') > -1) {
            $(document).one('fl_modal_closed', open_gmail_modal);
        } else {
            open_gmail_modal();
        }
    }

    function open_gmail_modal() {
        // hide flash movie if we are popping the modal
        if ($flash_content.length > 0) {
            $flash_content.hide();
        }

        var options = {
            modal_div: $modal_content,
            hide: function() {
                this.handlers.reset_scrollbar();

                $flash_content.show();
            }
        };
        GP.vent.trigger('Modal:open:static', options);
    }
});
